import { render, staticRenderFns } from "./role-layout.vue?vue&type=template&id=34bb22ef"
import script from "./role-layout.vue?vue&type=script&lang=js"
export * from "./role-layout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports